import f from "@babel/runtime/helpers/esm/objectSpread2";
import S from "@babel/runtime/helpers/esm/classCallCheck";
import P from "@babel/runtime/helpers/esm/createClass";
import g from "@babel/runtime/helpers/esm/assertThisInitialized";
import k from "@babel/runtime/helpers/esm/inherits";
import j from "@babel/runtime/helpers/esm/createSuper";
import d from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as T } from "@semcore/utils/lib/core/index";
import E, { assignProps as u, Component as O, sstyled as w } from "@semcore/core";
import l from "react";
import { Slide as I, FadeInOut as W } from "@semcore/animation";
import z, { PortalProvider as M } from "@semcore/portal";
import C from "@semcore/button";
import D from "@semcore/outside-click";
import R from "@semcore/icon/Close/l";
import h from "@semcore/utils/lib/fire";
import A from "@semcore/utils/lib/use/usePreventScroll";
import { isAdvanceMode as $ } from "@semcore/utils/lib/findComponent";
import H from "@semcore/utils/lib/enhances/keyboardFocusEnhance";
import { localizedMessages as x } from "./translations/__intergalactic-dynamic-locales.mjs";
import N from "@semcore/utils/lib/enhances/i18nEnhance";
import { Text as F } from "@semcore/typography";
import K from "@semcore/utils/lib/uniqueID";
import { cssVariableEnhance as Z } from "@semcore/utils/lib/useCssVariable";
import { useFocusLock as q } from "@semcore/utils/lib/use/useFocusLock";
import { useContextTheme as B } from "@semcore/utils/lib/ThemeProvider";
import { useColorResolver as L } from "@semcore/utils/lib/use/useColorResolver";
import { ZIndexStackingContextProvider as V, useZIndexStacking as G } from "@semcore/utils/lib/zIndexStacking";
var J = (
  /*__reshadow_css_start__*/
  (T.insert(
    /*__inner_css_start__*/
    ".___SWindow_wwtaj_gg_{position:relative;border-radius:var(--intergalactic-modal-rounded, 12px);background:var(--intergalactic-bg-primary-neutral, #ffffff);box-sizing:border-box;margin:auto;padding:var(--intergalactic-spacing-10x, 40px);box-shadow:var(--intergalactic-box-shadow-modal, 0px 3px 8px 0px rgba(25, 27, 35, 0.2));color:var(--intergalactic-text-primary, #191b23)}.___SWindow_wwtaj_gg_:focus{outline:0}.___SWindow_wwtaj_gg_ .___STitle_wwtaj_gg_{color:var(--intergalactic-text-primary, #191b23);font-size:var(--intergalactic-fs-500, 24px);line-height:var(--intergalactic-lh-500, 117%);font-weight:var(--intergalactic-semi-bold, 600);margin-bottom:var(--intergalactic-spacing-2x, 8px);margin-right:var(--intergalactic-spacing-4x, 16px)}.___SWindow_wwtaj_gg_ .___STitle_wwtaj_gg_.__color_wwtaj_gg_{color:var(--color_wwtaj)}.___SWindow_wwtaj_gg_ .___SClose_wwtaj_gg_{display:inline-flex;position:absolute;right:var(--intergalactic-spacing-2x, 8px);top:var(--intergalactic-spacing-2x, 8px)}.___SWindow_wwtaj_gg_ .___SClose_wwtaj_gg_.__ghost_wwtaj_gg_{right:0;top:0}.___SWindow_wwtaj_gg_.__ghost_wwtaj_gg_{background:0 0;padding:0;box-shadow:none}.___SOverlay_wwtaj_gg_{position:fixed;top:0;bottom:0;left:0;right:0;margin:0;display:flex;justify-content:center;align-items:center;padding:var(--intergalactic-spacing-10x, 40px);background:var(--intergalactic-overlay-primary, rgba(25, 27, 35, 0.7));overflow:auto;-webkit-overflow-scrolling:touch}.___SOverlay_wwtaj_gg_ .___SOverlay_wwtaj_gg_{background:var(--intergalactic-overlay-secondary, rgba(25, 27, 35, 0.4))}@media (max-width:767px){.___SWindow_wwtaj_gg_{min-width:60%}.___SOverlay_wwtaj_gg_{padding:var(--intergalactic-spacing-3x, 12px)}}",
    "wwtaj_gg_"
  ), {
    __SWindow: "___SWindow_wwtaj_gg_",
    _ghost: "__ghost_wwtaj_gg_",
    __SOverlay: "___SOverlay_wwtaj_gg_",
    __STitle: "___STitle_wwtaj_gg_",
    _color: "__color_wwtaj_gg_",
    "--color": "--color_wwtaj",
    __SClose: "___SClose_wwtaj_gg_"
  })
), v = /* @__PURE__ */ function(r) {
  k(a, r);
  var c = j(a);
  function a() {
    var n;
    S(this, a);
    for (var e = arguments.length, i = new Array(e), t = 0; t < e; t++)
      i[t] = arguments[t];
    return n = c.call.apply(c, [this].concat(i)), d(g(n), "state", {
      hasTitle: !1
    }), d(g(n), "handleKeyDown", function(o) {
      o.key === "Escape" && (o.stopPropagation(), h(g(n), "onClose", "onEscape", o));
    }), d(g(n), "handleIconCloseClick", function(o) {
      h(g(n), "onClose", "onCloseClick", o);
    }), d(g(n), "handleOutsideClick", function(o) {
      h(g(n), "onClose", "onOutsideClick", o);
    }), n;
  }
  return P(a, [{
    key: "getOverlayProps",
    value: function() {
      var e = this.asProps, i = e.duration, t = e.visible, o = e.animationsDisabled, s = e.disablePreventScroll;
      return {
        duration: i,
        visible: t,
        onOutsideClick: this.handleOutsideClick,
        animationsDisabled: o,
        disablePreventScroll: s
      };
    }
  }, {
    key: "getWindowProps",
    value: function() {
      var e = this.asProps, i = e.visible, t = e.closable, o = e.getI18nText, s = e.uid, _ = e.duration, p = e.animationsDisabled, b = this.state.hasTitle;
      return {
        visible: i,
        closable: t,
        onKeyDown: this.handleKeyDown,
        "aria-label": b ? void 0 : o("title"),
        "aria-labelledby": b ? "igc-".concat(s, "-title") : void 0,
        duration: _,
        animationsDisabled: p
      };
    }
  }, {
    key: "getCloseProps",
    value: function() {
      var e = this.asProps, i = e.getI18nText, t = e.ghost;
      return {
        onClick: this.handleIconCloseClick,
        getI18nText: i,
        ghost: t
      };
    }
  }, {
    key: "getTitleProps",
    value: function() {
      var e = this, i = this.asProps.uid, t = function() {
        return e.setState({
          hasTitle: !0
        });
      };
      return {
        id: "igc-".concat(i, "-title"),
        setHasTitle: t
      };
    }
  }, {
    key: "render",
    value: function() {
      var e = this.asProps, i = this.asProps, t = i.Children, o = i.disablePortal, s = i.forcedAdvancedMode, _ = i.ignorePortalsStacking, p = s || $(t, [m.Overlay.displayName, m.Window.displayName]);
      return /* @__PURE__ */ l.createElement(z, {
        disablePortal: o,
        ignorePortalsStacking: _
      }, p ? /* @__PURE__ */ l.createElement(t, null) : /* @__PURE__ */ l.createElement(m.Overlay, null, /* @__PURE__ */ l.createElement(m.Window, u({}, e))));
    }
  }]), a;
}(O);
d(v, "displayName", "Modal");
d(v, "style", J);
d(v, "enhance", [N(x), K(), Z({
  variable: "--intergalactic-duration-modal",
  fallback: "200",
  map: Number.parseInt,
  prop: "duration"
})]);
d(v, "defaultProps", {
  closable: !0,
  i18n: x,
  locale: "en",
  disablePreventScroll: !1
});
function Q(r) {
  var c = arguments[0], a, n = I, e = r.Children, i = r.styles, t = r.visible, o = r.closable, s = r.duration, _ = l.useRef(null);
  return q(_, !0, "auto", !t, !0), a = w(i), /* @__PURE__ */ l.createElement(n, a.cn("SWindow", f({}, u({
    initialAnimation: !0,
    slideOrigin: "top",
    visible: t,
    role: "dialog",
    "aria-modal": !0,
    duration: s,
    ref: _
  }, c))), /* @__PURE__ */ l.createElement(V, a.cn("ZIndexStackingContextProvider", {
    designToken: "z-index-modal"
  }), /* @__PURE__ */ l.createElement(M, a.cn("PortalProvider", {
    value: _
  }), o && /* @__PURE__ */ l.createElement(m.Close, null), /* @__PURE__ */ l.createElement(e, a.cn("Children", {})))));
}
function U(r) {
  var c = arguments[0], a, n = W, e = r.Children, i = r.styles, t = r.onOutsideClick, o = r.visible, s = l.useRef(null);
  A(o, r.disablePreventScroll), B(s, o);
  var _ = G("z-index-modal");
  return a = w(i), /* @__PURE__ */ l.createElement(n, a.cn("SOverlay", f({}, u({
    ref: s,
    zIndex: _
  }, c))), /* @__PURE__ */ l.createElement(D, a.cn("OutsideClick", {
    root: s,
    onOutsideClick: t
  }), /* @__PURE__ */ l.createElement(e, a.cn("Children", {}))));
}
function y(r) {
  var c = arguments[0], a, n = C, e = r.Children, i = r.children, t = r.getI18nText, o = r.ghost;
  return a = w(r.styles), /* @__PURE__ */ l.createElement(n, a.cn("SClose", f({}, u({
    use: "tertiary",
    size: "l",
    theme: o ? "invert" : "muted",
    "aria-label": t("close")
  }, c))), i ? /* @__PURE__ */ l.createElement(e, a.cn("Children", {})) : /* @__PURE__ */ l.createElement(C.Addon, {
    ml: "7px",
    mr: "7px"
  }, /* @__PURE__ */ l.createElement(R, a.cn("CloseIcon", {
    title: t("close")
  }))));
}
y.enhance = [H()];
function X(r) {
  var c = arguments[0], a, n = r.setHasTitle, e = r.styles, i = r.color, t = F, o = L();
  return l.useEffect(function() {
    return n();
  }), a = w(e), /* @__PURE__ */ l.createElement(t, a.cn("STitle", f({}, u({
    tag: "h2",
    "use:color": o(i)
  }, c))));
}
var m = E(v, {
  Window: Q,
  Overlay: U,
  Close: y,
  Title: X
});
export {
  m as default
};
